import { z } from 'zod';

/**
 * Schema for watermark settings data coming from the form (0-100 for
 * transparency). `scale` maxes out at 2 per `WatermarkSettings` in the
 * OpenAPI spec.
 */
export const zodWatermarkSettingsFormSchema = z.object({
  scale: z.coerce.number().min(0.1).max(2),
  transparent: z.coerce.number().min(0).max(100),
  x: z.coerce.number().min(0).max(595),
  y: z.coerce.number().min(0).max(842),
});

/**
 * Schema for watermark settings data to send to API (0-1 for transparency)
 */
export const zodWatermarkSettingsApiSchema =
  zodWatermarkSettingsFormSchema.transform((data) => ({
    ...data,
    // Convert transparent from percentage (0-100) to decimal (0-1) for the API
    transparent: data.transparent / 100,
  }));

/**
 * Schema for validating the endpoint path segments
 */
export const zodUpdateCompanyWatermarkSettingsEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('company'),
  z.uuid(),
  z.literal('watermark_settings'),
]);
